/*eslint-disable*/
import React, { useEffect, useRef, useState } from 'react';
import { Row, Card, Col, Label, Input, CardHeader, CardBody, FormGroup, CardTitle, Button, Container, Form, Collapse } from 'reactstrap';
import axios from 'axios';
import { Link } from "react-router-dom";
// import { useHistory } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import "./Style.css";
import MobileHeader from 'components/Headers/MobileHeader';
// import { getAddressMap } from "utils/getMapAddress";

const IstirahatPage = () => {
    const token = localStorage.token;
    const userid = localStorage.uic;
    const username = localStorage.username;
    const warehouseId = localStorage.warehouse;
    const codeAbsen = localStorage.ai;
    const [buttonStart, setButtonStart] = useState("");
    const [buttonExit, setButtonExit] = useState("");
    const [name, setName] = useState("");
    const [picture, setPicture] = useState("");
    const [jabatan, setJabatan] = useState("");
    const [allDocument, setAllDocument] = useState([]);
    const [tanggal, setTanggal] = useState("");
    const [loading1, setLoading1] = useState(false)
    const [loading4, setLoading4] = useState(false)
    const [loadings, setLoadings] = useState(false)
    const [Start, setStart] = useState("");
    const [End, setEnd] = useState("");
    const [collapse, setCollapse] = useState(false);

    const toggle = () => setCollapse(!collapse);


    // const getTodayDate = () => {
    //     const today = new Date();
    //     const year = today.getFullYear();
    //     const month = String(today.getMonth() + 1).padStart(2, '0'); // bulan dimulai dari 0
    //     const day = String(today.getDate()).padStart(2, '0');
    //     return `${year}-${month}-${day}`;
    // };

    const getAllDokument = (start = null, end = null) => {
        setLoadings(true)
        // const today = getTodayDate(); // Ambil tanggal hari ini
        const filter = {
            page: 1,
            per_page: 50,
            start: start || Start,
            end: end || End,
            warehouse_id: parseInt(warehouseId),
            username: username,
        };

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .post(
                `${process.env.REACT_APP_API_BASE_URL}/absensi-break/page`,
                filter,
                { headers }
            )
            .then((res) => {
                setLoadings(false)
                const responseData = res.data.response || [];
                setAllDocument(responseData);
                // // console.log("rfq_flag semua dokumen:", responseData.map(doc => doc.rfq_flag));

                // // Cek apakah semua rfq_flag === 1 → hide tombol resume
                // const isAllOne = responseData.length > 0 && responseData.every(doc => doc.rfq_flag === 1);
                // const isAllTwo = responseData.length > 0 && responseData.every(doc => doc.rfq_flag === 2);

                // if (isAllOne) {
                //     setCanResume(false);
                // } else if (isAllTwo) {
                //     setCanResume(true);
                // } else {
                //     setCanResume(false); // fallback untuk kondisi campuran
                // }

            })
            .catch((error) => {
                setLoadings(false)
                console.error(error);
                setAllDocument(error.response.data.response);
            });
    };



    useEffect(() => {
        getAllDokument(Start, End);
    }, []);


    const saveInIstirahat = () => {
        setLoading1(true)
        // if (!lat || !long || !username || !address) return;

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        const payload = {
            absensi_karyawan_id: codeAbsen,
        };

        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/absensi-break/in`, payload, { headers })
            .then((res) => {
                getAllDokument()
                // getCekSalesTrack()
                setLoading1(false)

            })
            .catch((error) => {
                console.error("Gagal simpan data:", error.response?.data || error.message);
                setLoading1(false)

            });
    };

    const saveOutIstirahat = () => {
        setLoading1(true)
        // if (!lat || !long || !username || !address) return;

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        const payload = {
            absensi_karyawan_id: codeAbsen,
        };

        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/absensi-break/out`, payload, { headers })
            .then((res) => {
                getAllDokument()
                // getCekSalesTrack()
                setLoading1(false)

            })
            .catch((error) => {
                console.error("Gagal simpan data:", error.response?.data || error.message);
                setLoading1(false)

            });
    };

    const successCallback = (position) => {
    };

    const errorCallback = (error) => {
    };

    navigator.geolocation.getCurrentPosition(successCallback, errorCallback);

    useEffect(() => {
        setInterval(() => {
            ceklangtut()
        }, 2000);
        getByUser()
    }, [])

    const ceklangtut = () => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                const { latitude, longitude } = position.coords;
                getLokasi(latitude, longitude); // langsung kirim
            },
            (err) => {
                console.error("Gagal mendapatkan lokasi", err);
            }
        );
    };

    const getLokasi = (lat, long) => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        const data = {
            username: username,
            latitude: lat,
            longitude: long,
        };

        axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/absensi-karyawan/get-by-username`, data, { headers })
            .then((data) => {
                setButtonStart(data.data.response.status_break);
                setButtonExit(data.data.response.status_break);
                localStorage.setItem("ai", data.data.response.absensi_karyawan_id);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    // const getCekSalesTrack = () => {
    //     setLoadings(true)

    //     if (!username) return;

    //     const headers = {
    //         "Content-Type": "application/json",
    //         Authorization: `Bearer ${token}`,
    //     };

    //     axios
    //         .get(`${process.env.REACT_APP_API_BASE_URL}/sales-track/check-by-username/${username}`, { headers })
    //         .then((res) => {
    //             const isPresent = res.data.response.is_present;
    //             setLoadings(false)
    //             setButtonStart(isPresent);
    //             window.localStorage.setItem("tc", res.data.response.tracking_code);


    //             if (isPresent === 1) {
    //                 console.log("✅ is_present dari API Awal:", isPresent); // ⬅️ Tambahkan ini
    //                 // Aktifkan interval jika belum ada
    //                 if (!intervalId) {
    //                     console.log("✅ is_present dari API Akhir:", isPresent); // ⬅️ Tambahkan ini
    //                     const id = setInterval(() => {
    //                         sendTrackingUpdate(1);
    //                     }, 500000);
    //                     setIntervalId(id);
    //                     console.log("⏱️ Tracking aktif tiap 1 menit");
    //                 }
    //             } else {
    //                 // Stop interval jika bukan is_present === 1
    //                 if (intervalId) {
    //                     clearInterval(intervalId);
    //                     setIntervalId(null);
    //                     setLoadings(false)
    //                     console.log("🛑 Tracking otomatis dimatikan");
    //                 }
    //             }
    //         })
    //         .catch((error) => {
    //             console.log("Gagal ambil status sales-track:", error);
    //         });
    // };

    const reset = () => {
        setStart("");
        setEnd("");
        getAllDokument(1, "", "");
    };

    const getByUser = () => {
        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/users/profil/${userid}`, { headers })
            .then((res) => {
                const user = res.data.response;
                setName(user.name);
                setPicture(user.karyawan_image);
                setJabatan(user.jabatan);
            })
            .catch((error) => {
                console.log("Gagal ambil profil:", error);
            });
    };


    return (
        <div>
            <MobileHeader name={name} picture={picture} jabatan={jabatan} />
            <Container className="mt--5" fluid>
                <Row>
                    {loadings ? (
                        // Tampilan loading saat data sedang dimuat
                        <div className="col d-flex justify-content-center align-items-center" style={{ minHeight: "70vh" }}>
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                                <p className="mt-2">Memuat data, tunggu sebentar...</p>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="col">
                                <Card>
                                    <CardHeader>
                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                            <h2>Histori Istirahat</h2>
                                            <Button
                                                color="link"
                                                onClick={toggle}
                                                className="p-0"
                                            >
                                                {collapse ? (
                                                    <i className="fa fa-minus" aria-hidden="true"></i>
                                                ) : (
                                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                                )}
                                            </Button>
                                        </div>
                                        <Collapse isOpen={collapse}>
                                            <div className="mt-3">
                                                <Row className="gx-2 gy-2">
                                                    <Col xs="12" md="4">
                                                        <FormGroup>
                                                            <Label className="form-control-label">Tanggal Awal</Label>
                                                            <Input
                                                                autoComplete="off"
                                                                type="date"
                                                                value={Start}
                                                                onChange={(e) => setStart(e.target.value)}
                                                            />
                                                        </FormGroup>
                                                        {Start}
                                                    </Col>
                                                    <Col xs="12" md="4">
                                                        <FormGroup>
                                                            <Label className="form-control-label">Tanggal Akhir</Label>
                                                            <Input
                                                                autoComplete="off"
                                                                type="date"
                                                                value={End}
                                                                onChange={(e) => setEnd(e.target.value)}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col xs="6" md="2" className="d-flex align-items-end">
                                                        <Button
                                                            type="button"
                                                            onClick={() => getAllDokument(Start, End)}
                                                            className="btn btn-info w-100"
                                                        >
                                                            <i className="fa fa-filter" />
                                                        </Button>
                                                    </Col>
                                                    <Col xs="6" md="2" className="d-flex align-items-end">
                                                        <Button
                                                            type="button"
                                                            onClick={reset}
                                                            className="btn btn-secondary w-100"
                                                        >
                                                            Reset
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Collapse>
                                    </CardHeader>
                                    <CardBody>
                                        {allDocument === null || allDocument === "" ? (
                                            <div className="d-lg-none d-xl-none">
                                                <CardHeader>
                                                    <center><h3>DATA NOT FOUND</h3></center>
                                                </CardHeader>
                                            </div>
                                        ) : (
                                            <>
                                                <PerfectScrollbar>
                                                    <div className=" d-lg-none d-xl-none" style={{ top: 100, zIndex: "3", maxHeight: "35rem", paddingTop: "0.5rem" }}>
                                                        <Form >
                                                            <div>
                                                                {allDocument.map((v) => {
                                                                    let badgeColor = "secondary";
                                                                    let badgeText = "Baru";
                                                                    let dynamicLink = "/mobile/canvasing/detail/" + v.canvasing_code;
                                                                    let onClickAction = () => { }; // default, tidak ngapa-ngapain

                                                                    if (v.status_break === 3 && v.active_flag === 1 && v.rfq_flag === 1) {
                                                                        badgeColor = "warning";
                                                                        badgeText = "Proses";
                                                                        dynamicLink = "/mobile/canvasing/penawaran/" + v.canvasing_code;
                                                                    } else if (v.status_break === 3 && v.active_flag === 1 && v.rfq_flag === 2) {
                                                                        badgeColor = "danger";
                                                                        badgeText = "Ditolak";
                                                                        dynamicLink = "/mobile/canvasing/detail/" + v.canvasing_code;
                                                                    }
                                                                    // <Link
                                                                    //     to={redirectPrefix + v.canvasing_code}
                                                                    //     id={"tooltip_" + v.canvasing_code}
                                                                    // >
                                                                    return (
                                                                        // <Link to={dynamicLink} key={v.id} onClick={onClickAction}>

                                                                        <Card className="bg-gradient-info" style={{ marginBottom: "0.75rem" }}>
                                                                            <CardBody>
                                                                                <Row className="align-items-center">
                                                                                    <Col>
                                                                                        {/* Nama Customer */}
                                                                                        <CardTitle className="h5 text-uppercase text-white mb-1">
                                                                                            {v.status_break === 1 ? "MULAI" : v.status_break === 5 ? "TIDAK" : "SELESAI"} ISTIRAHAT
                                                                                        </CardTitle>

                                                                                        {/* Nama Proyek */}
                                                                                        <div className="text-white font-weight-bold">
                                                                                            <i className="fa fa-calendar mr-1" />{v.tgl ?? '-'} {v.break_at ?? '-'}
                                                                                        </div>
                                                                                    </Col>

                                                                                    {/* Icon Status */}
                                                                                    <Col className="col-auto">
                                                                                        {v.status_break === 2 ? (
                                                                                            <div className="icon icon-shape bg-white text-success rounded-circle shadow">
                                                                                                <i className="fa fa-check" />
                                                                                            </div>
                                                                                        ) : v.status_break === 1 ? (
                                                                                            <div className="icon icon-shape bg-white text-danger rounded-circle shadow">
                                                                                                <i className="fa fa-check" />
                                                                                            </div>
                                                                                        ) : (
                                                                                            <div className="icon icon-shape bg-white text-success rounded-circle shadow">
                                                                                                <i className="fa fa-check" />
                                                                                            </div>
                                                                                        )}
                                                                                    </Col>
                                                                                </Row>
                                                                            </CardBody>
                                                                        </Card>
                                                                    )
                                                                })
                                                                }
                                                            </div>
                                                        </Form>
                                                    </div>
                                                </PerfectScrollbar>
                                            </>
                                        )}
                                    </CardBody>
                                </Card>
                            </div>
                        </>
                    )}
                </Row>
            </Container>
            <nav className="navbar navbar-bottom bg-white navbar-expand fixed-bottom d-md-none d-lg-none d-xl-none">
                <ul className="navbar-nav nav-justified w-100 position-relative">
                    <li className="nav-item">
                        <a href="/mobile/staff-absen" className="nav-link text-center">
                            <i className="fas fa-home fa-lg d-block mb-1" />
                            <span className="small">Home</span>
                        </a>
                    </li>

                    <li className="nav-item">
                        <div className="fab-center-button">
                            {buttonStart === 5 && (
                                <div className="rounded-circle p-0 d-flex justify-content-center align-items-center" style={{ height: "70px", width: "70px" }}>
                                    <i className="fa fa-times fa-2x" />
                                </div>
                            )}
                            {buttonStart === 4 && (
                                <Button
                                    color="success"
                                    disabled={loading1}
                                    onClick={() => saveInIstirahat()}
                                    className="rounded-circle p-0 d-flex justify-content-center align-items-center"
                                    style={{ height: "70px", width: "70px" }}
                                >
                                    <i className="fas fa-play fa-2x" />
                                </Button>
                            )}
                            {buttonExit === 1 && (
                                <Button
                                    color="danger"
                                    disabled={loading4}
                                    onClick={() => saveOutIstirahat()}
                                    className="rounded-circle p-0 d-flex justify-content-center align-items-center"
                                    style={{ height: "70px", width: "70px" }}
                                >
                                    <i className="fas fa-stop fa-2x" />
                                </Button>
                            )}
                        </div>
                    </li>

                    <li className="nav-item">
                        <a href="/mobile/profile" className="nav-link text-center">
                            <i className="fas fa-user fa-lg d-block mb-1" />
                            <span className="small">Akun</span>
                        </a>
                    </li>
                </ul>
            </nav>

        </div>
    );
};

export default IstirahatPage;
